import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '../contexts/TranslationContext';
import { MOBILE_TAB_ROUTES, shouldShowMobileTabBar } from './mobileNavConfig';

export default function MobileBottomNav({ onOpenMenu }) {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  if (!shouldShowMobileTabBar(pathname)) return null;

  return (
    <nav className="mobile-bottom-nav" aria-label={t('mobile.tabs.label')}>
      {MOBILE_TAB_ROUTES.map(({ id, to, labelKey, Icon, action }) => {
        const active = to ? (pathname === to || (to !== '/' && pathname.startsWith(to))) : false;
        const cls = `mobile-bottom-nav__item${active ? ' mobile-bottom-nav__item--active' : ''}`;

        if (action === 'menu') {
          return (
            <button key={id} type="button" className={cls} onClick={onOpenMenu}>
              <Icon className="mobile-bottom-nav__icon" aria-hidden />
              <span className="mobile-bottom-nav__label font-marathi">{t(labelKey)}</span>
            </button>
          );
        }

        return (
          <Link key={id} to={to} className={cls}>
            <Icon className="mobile-bottom-nav__icon" aria-hidden />
            <span className="mobile-bottom-nav__label font-marathi">{t(labelKey)}</span>
          </Link>
        );
      })}
    </nav>
  );
}
